<template>
  <div class="homework">
    <div class="header">
      <el-row :gutter="1" type="flex">
        <el-col :span="9"
          ><span class="title">统计日期:</span>
          <datePicker
            :value="{ startDate: searchForm.startDate, endDate: searchForm.endDate }"
            @dateValue="dateValue"
          />
        </el-col>
        <el-col :span="6"
          ><span class="title">省市区:</span
          ><el-cascader
            :options="options"
            v-model="cityValue"
            :props="{ multiple: true }"
            collapse-tags
            clearable
            @change="cityChange"
            @visible-change="cityVisible"
            @remove-tag="removeTag"
          ></el-cascader
        ></el-col>
        <el-col :span="6"
          ><span class="title">学校:</span
          ><filterSelect ref="filterSelect" :optionsList="schoolList" @checked="schoolChecked"
        /></el-col>
        <el-col :span="3"
          ><div class="btn">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="search">查询</el-button>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          <el-tabs v-model="activeName" @tab-click="handleClickTabs">
            <el-tab-pane name="平台作业">
              <div slot="label">
                平台作业
                <el-popover
                  placement="bottom-start"
                  width="600"
                  trigger="hover"
                  :visible-arrow="false"
                  popper-class="popper-hint"
                >
                  <div v-html="PTZY"></div>
                  <i class="el-icon-info" slot="reference"></i>
                </el-popover>
              </div>
            </el-tab-pane>
            <el-tab-pane name="AI智能卡">
              <div slot="label">
                AI智能卡
                <el-popover
                  placement="bottom-start"
                  width="500"
                  trigger="hover"
                  :visible-arrow="false"
                  popper-class="popper-hint"
                >
                  <div v-html="AIZNK"></div>
                  <i class="el-icon-info" slot="reference"></i>
                </el-popover>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="downExcel" :loading="downLoading">导出数据</el-button>
        </div>
      </div>
      <div class="table">
        <!-- 平台作业 -->
        <el-table
          v-if="!emptyIsShow && activeName == '平台作业'"
          :data="tableDataHomework"
          :key="keytable1"
          ref="table1"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          v-loading="loading"
          @sort-change="sortChange"
          height="100%"
          :default-sort="{ prop: 'totalTeaNum', order: 'descending' }"
        >
          <el-table-column fixed type="index" label="排名" min-width="80">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed prop="schoolName" label="学校名称" width="220"> </el-table-column>
          <el-table-column sortable="custom" prop="totalTeaNum" label="教师总数" min-width="120"> </el-table-column>
          <el-table-column sortable="custom" prop="teacherHteNum" label="布置作业教师数" min-width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="teacherHtePent" label="布置作业教师占比" min-width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="teacherCollectNum" label="收集作业教师数" min-width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="teacherCollectPent" label="收集作业教师占比" min-width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="teacherLecturersNum" label="讲解作业教师数" min-width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="teacherLecturersPent" label="讲解作业教师占比" min-width="150">
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button type="text" class="detail-btn" @click="goDetail(scope.row)">教师明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- AI智能卡 -->
        <el-table
          v-if="!emptyIsShow && activeName == 'AI智能卡'"
          :key="keytable2"
          :data="tableDataAi"
          ref="table2"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          v-loading="loading"
          height="100%"
          @sort-change="sortChange"
          :default-sort="{ prop: 'totalTeaNum', order: 'descending' }"
        >
          <el-table-column fixed type="index" label="排名" width="80">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed prop="schoolName" label="学校名称" min-width="220"> </el-table-column>
          <el-table-column sortable="custom" prop="totalTeaNum" label="教师总数" min-width="120"> </el-table-column>
          <el-table-column sortable="custom" prop="teacherHteNum" label="采集AI智能卡教师数" min-width="160">
          </el-table-column>
          <el-table-column sortable="custom" prop="teacherHtePent" label="采集AI智能卡教师占比" min-width="170">
          </el-table-column>
          <el-table-column sortable="custom" prop="teacherSpeakNum" label="讲解AI智能卡教师数" min-width="160">
          </el-table-column>
          <el-table-column sortable="custom" prop="teacherSpeakPent" label="讲解AI智能卡教师占比" min-width="170">
          </el-table-column>

          <el-table-column fixed="right" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button type="text" class="detail-btn" @click="goDetail(scope.row)">教师明细</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-empty v-if="emptyIsShow" description="暂无数据" :image-size="80" style="margin-top: 100px"></el-empty>
      <div class="pagSize" v-if="!emptyIsShow">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import filterSelect from '../../components/FilterSelect/index.vue'
// import newDate from "../../components/newDate";
import datePicker from '../../components/datePicker/index.vue'
import { PTZY, AIZNK } from '@/utils/explainText.js'
import { lastWeek } from '@/utils/date.js'
import { calculate } from '@/utils/number.js'
// import { saveAs } from 'file-saver'
import fileSave from '@/utils/fileSave.js'

import { homeworkList, AIList } from '@/api/modules/excelApi.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
import { resize } from '@/mixins/resize.js'
export default {
  name: 'HomeworkAnalysis',
  mixins: [resize],
  components: {
    filterSelect,
    // newDate,
    datePicker
  },
  data() {
    return {
      schoolList: JSON.parse(sessionStorage.getItem('schoolList')),
      activeName: '平台作业',
      tableDataHomework: [],
      tableDataAi: [],
      PTZY: PTZY,
      AIZNK: AIZNK,
      searchForm: {
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key,
        schoolIds: [],
        pageNum: 1,
        pageSize: 12,
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        sortCode: 'totalTeaNum',
        ascOrDes: false //false是降序,true是升序
      },
      loading: false,
      total: 0,
      emptyIsShow: false,
      options: JSON.parse(sessionStorage.getItem('cityList')),
      address: {
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key
      },
      cityValue: [],
      keytable2: 10,
      keytable1: 0,
      downLoading: false
    }
  },
  computed: {},
  activated() {
    window.addEventListener('resize', this.tableLayout)
    this.tableLayout()
  },
  deactivated() {
    // console.log("deactivated");
    window.removeEventListener('resize', this.tableLayout)
  },
  created() {
    this.homeworkGetList()
  },
  mounted() {},
  methods: {
    // 表格重绘
    tableLayout() {
      // console.log('组件方法');
      if (this.activeName == 'AI智能卡') {
        this.$refs.table2.doLayout()
      } else if (this.activeName == '平台作业') {
        this.$refs.table1.doLayout()
      }
    },
    //表格数据
    homeworkGetList() {
      this.loading = true
      this.$API.homeworkAnalysisApi
        .platformHomework(this.searchForm)
        .then((res) => {
          // console.log(res);
          this.tableDataHomework = res.result
          if (this.tableDataHomework.length > 0) {
            this.emptyIsShow = false
            this.total = this.tableDataHomework[0].total
            this.tableDataHomework.forEach((el) => {
              el.teacherLecturersPent = el.teacherLecturersPent + '%'
              el.teacherHtePent = el.teacherHtePent + '%'
              el.teacherCollectPent = el.teacherCollectPent + '%'
            })
          } else {
            this.total = 0
            this.emptyIsShow = true
          }

          // console.log(this.tableDataHomework);
        })
        .finally(() => {
          this.loading = false
          this.tableLayout()
        })
    },
    // ai智能卡数据
    aiGetList() {
      this.loading = true
      this.$API.homeworkAnalysisApi
        .aiList(this.searchForm)
        .then((res) => {
          // console.log(res);
          this.tableDataAi = res.result
          if (this.tableDataAi.length > 0) {
            this.emptyIsShow = false
            this.total = this.tableDataAi[0].total
            this.tableDataAi.forEach((el) => {
              el.teacherSpeakPent = el.teacherSpeakPent + '%'
              el.teacherHtePent = el.teacherHtePent + '%'
            })
          } else {
            this.total = 0
            this.emptyIsShow = true
          }

          // console.log(this.tableDataAi);
        })
        .finally(() => {
          this.loading = false
          this.tableLayout()
        })
    },
    handleClickTabs(tab) {
      this.activeName = tab.name
      this.searchForm.pageNum = 1
      this.searchForm.ascOrDes = false
      if (this.activeName == 'AI智能卡') {
        this.searchForm.sortCode = 'totalTeaNum'
        this.keytable2 += 1
        this.aiGetList()
      } else if (this.activeName == '平台作业') {
        this.searchForm.sortCode = 'totalTeaNum'
        this.keytable1 += 1
        this.homeworkGetList()
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.searchForm.pageNum = val
      if (this.activeName == 'AI智能卡') {
        this.aiGetList()
      } else if (this.activeName == '平台作业') {
        this.homeworkGetList()
      }
    },
    search() {
      this.searchForm.pageNum = 1
      if (this.activeName == 'AI智能卡') {
        this.aiGetList()
      } else if (this.activeName == '平台作业') {
        this.homeworkGetList()
      }
    },
    // 教师明细
    goDetail(v) {
      let info = {
        schoolId: v.schoolId,
        activeName: this.activeName,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate
      }
      this.$router.push({
        name: 'HomeworkTecDetail',
        query: info
      })
    },
    // date组件事件
    dateValue(v) {
      this.searchForm.startDate = v.startDate
      this.searchForm.endDate = v.endDate
      // console.log(this.searchForm.startDate, this.searchForm.endDate, "value");
    },
    // 学校选择器事件
    schoolChecked(v) {
      // console.log(v, "schoolChecked");
      this.searchForm.schoolIds = []
      v.forEach((el) => {
        this.searchForm.schoolIds.push(el.value)
      })
    },
    // 省市区选择器
    cityChange(v) {
      this.address = this.$options.data().address
      this.searchForm.provinceIds = this.searchForm.cityIds = this.searchForm.localeIds = []
      if (v.length < 1) {
        this.getSchools()
      }
      v.forEach((el) => {
        this.address.provinceIds.push(el[0])
        this.searchForm.provinceIds = this.address.provinceIds
        this.address.cityIds.push(el[1])
        this.searchForm.cityIds = this.address.cityIds
        this.address.localeIds.push(el[2])
        this.searchForm.localeIds = this.address.localeIds
      })
    },
    removeTag(v) {
      // console.log(v);
      let i = this.address.provinceIds.findIndex((el) => el == v[0])
      this.address.provinceIds.splice(i, 1)
      this.address.cityIds.splice(i, 1)
      this.address.localeIds.splice(i, 1)
      if (this.address.provinceIds.length > 0) {
        this.getSchools()
      }
    },
    // 省市区选择器收起时
    cityVisible(v) {
      if (!v && this.address.provinceIds.length > 0) {
        // console.log("请求");
        this.getSchools()
      }
    },
    getSchools() {
      this.$API.basicsApi.getSchoolList(this.address).then((res) => {
        console.log(res)
        this.searchForm.schoolIds = []
        this.$refs.filterSelect.checkedValue = ''
        this.schoolList = res.result.map((el) => {
          el.label = el.schoolName
          el.value = el.schoolId
          delete el.schoolId
          delete el.schoolName
          delete el.total
          return el
        })
      })
    },
    // 重置
    reset() {
      this.searchForm = this.$options.data().searchForm
      this.$refs.filterSelect.checkedValue = ''
      this.cityValue = []
      this.address = this.$options.data().address
      this.schoolList = JSON.parse(sessionStorage.getItem('schoolList'))
      if (this.activeName == 'AI智能卡') {
        this.keytable2 += 1
        this.aiGetList()
      } else if (this.activeName == '平台作业') {
        this.keytable1 += 1
        this.homeworkGetList()
      }
    },
    sortChange({ column, prop, order }) {
      this.searchForm.sortCode = prop
      if (order !== null) {
        order == 'descending' ? (this.searchForm.ascOrDes = false) : (this.searchForm.ascOrDes = true)
        if (this.activeName == 'AI智能卡') {
          this.aiGetList()
        } else if (this.activeName == '平台作业') {
          this.homeworkGetList()
        }
      }

      // console.log(column, prop, order);
    },
    // 导出数据
    downExcel() {
      this.downLoading = true

      let obj = {
        fileName: '',
        ...this.searchForm,
        ...getToken()
      }
      delete obj.pageSize
      delete obj.pageNum
      if (this.activeName == 'AI智能卡') {
        obj.fileName = excelName('学校AI智能卡使用分析', obj.startDate, obj.endDate)
        fileSave(AIList + generateTableParms(obj), obj.fileName + '.xlsx').then(() => {
          this.downLoading = false
        })
      } else if (this.activeName == '平台作业') {
        obj.fileName = excelName('学校平台作业使用分析', obj.startDate, obj.endDate)
        fileSave(homeworkList + generateTableParms(obj), obj.fileName + '.xlsx').then(() => {
          this.downLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.homework {
  @include myMain();
  .header {
    @include myHeader();
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
      /deep/ .el-tabs__item {
        font-size: 16px;
      }
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
    ::v-deep #tab-平台作业,
    #tab-AI智能卡 {
      height: 64px;
      line-height: 64px;
    }
    ::v-deep .el-tabs__header {
      margin: 12px 0 15px;
    }
    ::v-deep .el-tabs__nav-wrap::after {
      height: 0px;
    }
  }
}
</style>
